import { IRequestOptions } from "../IRequestOptions";
import { tms } from "../tms";
import { request } from "@fanfanlo";

/**
 * 获取未处理被邀请信息的请求参数
 */
export interface IParamsListPendingReceivedInvitations {
  // 可以添加分页等参数
  page?: number;
  page_size?: number;
}

/**
 * 未处理的被邀请信息
 */
export interface IPendingInvitationInfo {
  invitation_id: string;
  user_info: {
    user_id: string;
    display_name: string;
    avatar_url?: string;
  };
  status: 'pending';
  message: string;
  created_at: number;
  expires_at: number;
}

/**
 * 获取未处理被邀请信息的响应结果
 */
export interface IResultListPendingReceivedInvitations {
  is_ok: boolean;
  msg?: string;
  invitations: IPendingInvitationInfo[];
}

/**
 * 获取未处理的被邀请信息
 */
export async function tmsEmergencyCallListPendingReceivedInvitations(
  opts: IRequestOptions<IParamsListPendingReceivedInvitations>
) {
  return request<IResultListPendingReceivedInvitations, IParamsListPendingReceivedInvitations>(
    tms.TEmc,
    tms.MEmcListPendingReceivedInvitations,
    opts.params,
    opts.gateway,
    opts.handler
  );
}

// 导出服务
export const emergencyCallPendingInvitationService = {
  listPendingReceivedInvitations: tmsEmergencyCallListPendingReceivedInvitations,
};

export default emergencyCallPendingInvitationService;